export default "__VITE_ASSET__B32F3T6y__ 400w, __VITE_ASSET__BZ0OYBqo__ 640w, __VITE_ASSET__B0QGUi$4__ 896w";